<template>
  <ui-ui-button-ico
    icon="info-circle"
    :responsive-ico="true"
    size-ico="28"
    :responsive-sizes="[24, 24, 24, 28, 28, 28]"
    class="info-window-tile-offer"
    type="tertiary"
    fill="white"
    stroke="#86888F"
    @click.prevent.stop="$emit('show-view-offer')"
  />
</template>

<script setup lang="ts">
defineEmits(['show-view-offer']);
</script>

<style scoped lang="scss">
.info-window-tile-offer {
  position: absolute;
  z-index: 10;
  cursor: pointer;
  top: 6px;
  right: 6px;
}
</style>
